import { useContext, type FC } from 'react';
import type { OpenInterestProps } from './types';
import OpenInterestContent from './open-interest-content';
import { Widget } from '../../widget';
import TokenSelector from '../../token-selector';
import { OpenInterestContext } from '../../../../providers/widgets/open-interest-provider/open-interest-provider';
import WidgetButtons from '../../widget-buttons';

const OpenInterestWidget: FC<OpenInterestProps> = (props) => {
  const { widget, actions } = props;

  const { token, setToken, hasDefaultToken } = useContext(OpenInterestContext);

  return (
    <Widget cardKey={widget.key}>
      <Widget.Header>
        <Widget.Title title={widget.title} />
        <Widget.HeaderPanel>
          <TokenSelector token={token} setToken={setToken} isFixedToken={hasDefaultToken} />
        </Widget.HeaderPanel>
        <Widget.Buttons>
          <WidgetButtons widget={widget} actions={actions} permissions={props.permissions} />
        </Widget.Buttons>
      </Widget.Header>
      <Widget.Content>
        <OpenInterestContent providerKey={props.providerKey} />
      </Widget.Content>
      <Widget.Footer />
    </Widget>
  );
};

export default OpenInterestWidget;
